import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { MenuSelectComponent } from './menu-select.component';
import { MenuPanelModule } from '../menu-panel/menu-panel.module';


@NgModule({
  declarations: [
    MenuSelectComponent
  ],
  exports: [
    MenuSelectComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MenuPanelModule
  ]
})
export class MenuSelectModule { }
